import React, { useState, useEffect } from 'react'
import { Storage, API } from 'aws-amplify'
import { getOrganization, getLocation } from '../../managers/graphql/queries'
import queryString from 'query-string'
import { BORDER_RADIUS } from '../../theme/muiTheme'

import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import Chip from '@mui/material/Chip'
import Checkbox from '@mui/material/Checkbox'

import ProfileAvatar from '../../components/data-display/ProfileAvatar'

import { useAppSelector, useAppDispatch } from '../../hooks'
import { getOrganizationHeaderImage } from '../../managers/redux/slices/organization'
import { AuthAccount, StaffProfile, Organization, Location } from '../../API'
import ManageOrganization from '../../components/dialogs/organization/ManageOrganization'

export default function OrganizationProfile(props: any) {

    const dispatch = useAppDispatch()

    const [showManageOrganizationDialog, setShowManageOrganizationDialog] = useState<boolean>(false)

    const authAccount: AuthAccount | null | undefined = useAppSelector(state => state.authAccount.data)
    const selectedStaffProfile: StaffProfile | null = useAppSelector(state => state.authAccount.selectedStaffProfile)
    const organizationHeaderImage: string | null = useAppSelector(state => state.organization.organizationHeaderImage)

    const [loadedLocation, setLoadedLocation] = useState<Location | null>(null)

    const [selectedOrganization, setSelectedOrganization] = useState<Organization | null>(null)
    const [selectedOrganizationHeaderImage, setSelectedOrganizationHeaderImage] = useState<string | null>(null)
    const [selectedOrganizationProfilePicture, setSelectedOrganizationProfilePicture] = useState<string | null>(null)

    useEffect(() => {
        (async () => {
            if (authAccount) {
                const queryParams = queryString.parse(window.location.search)
                if (queryParams.id) {
                    const getOrganizationResponse: any = await API.graphql({
                        query: getOrganization,
                        variables: {
                            id: queryParams.id
                        }
                    })

                    console.log('getOrganizationResponse: ', getOrganizationResponse)

                    if (getOrganizationResponse && getOrganizationResponse.data && getOrganizationResponse.data.getOrganization) {
                        setSelectedOrganization(getOrganizationResponse.data.getOrganization)
                        const uri = await Storage.get(`organizations/${getOrganizationResponse.data.getOrganization.id}/headerImage`)
                        setSelectedOrganizationHeaderImage(uri)
                        const profilePictureUri = await Storage.get(`organizations/${getOrganizationResponse.data.getOrganization.id}/profilePicture`)
                        setSelectedOrganizationProfilePicture(profilePictureUri)

                        if (getOrganizationResponse.data.getOrganization.location && getOrganizationResponse.data.getOrganization.location.addressID && (getOrganizationResponse.data.getOrganization.location.address == undefined || getOrganizationResponse.data.getOrganization.location.address == null)) {
                            const getLocationResponse: any = await API.graphql({
                                query: getLocation,
                                variables: {
                                    id: getOrganizationResponse.data.getOrganization.locationID
                                }
                            })

                            setLoadedLocation(getLocationResponse.data.getLocation)
                        }
                    }
                } else {
                    setSelectedOrganization(selectedStaffProfile && selectedStaffProfile.organization ? selectedStaffProfile.organization : null)

                    dispatch(getOrganizationHeaderImage())

                    console.log('setSelectedOrganization: ', selectedStaffProfile && selectedStaffProfile.organization ? selectedStaffProfile.organization : null)

                    if (selectedStaffProfile && selectedStaffProfile.organization && selectedStaffProfile.organization.location && selectedStaffProfile.organization.location.addressID && (selectedStaffProfile.organization.location.address == undefined || selectedStaffProfile.organization.location.address == null)) {
                        const getLocationResponse: any = await API.graphql({
                            query: getLocation,
                            variables: {
                                id: selectedStaffProfile.organization.locationID
                            }
                        })

                        setLoadedLocation(getLocationResponse.data.getLocation)
                    }
                }
            }
        })()
    }, [authAccount])

    if (selectedOrganization && selectedStaffProfile && selectedStaffProfile.organizationID && selectedStaffProfile.organizationID == selectedOrganization.id) {
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 border-bottom">
                        <div className="d-flex flex-row justify-content-between align-items-center my-5">
                            <Typography variant="h3" sx={{ fontFamily: 'Gilroy-Medium' }}>Organization Profile</Typography>
                            {
                                selectedStaffProfile && selectedStaffProfile.role == 'admin' &&
                                <Button variant="outlined" onClick={() => { setShowManageOrganizationDialog(true) }}>Edit</Button>
                            }
                        </div>
                    </div>
                    <div className="col-12 col-lg-6 mt-5">
                        <img src={organizationHeaderImage ? organizationHeaderImage : ''} style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: BORDER_RADIUS }} />
                    </div>
                    <div className="col-12 col-lg-6 mt-lg-5">
                        <div className="d-flex flex-column justify-content-center align-items-start mb-2">
                            <ProfileAvatar organizationID={selectedOrganization.id} size={'large'} className="my-2" />
                            <Typography variant="h3">{selectedOrganization.name}</Typography>
                            <div className="d-flex flex-row justify-content-start align-items-center my-2">
                                <Typography variant="body1">On Flourish since {new Date(selectedOrganization.createdAt).toLocaleDateString()}</Typography>
                            </div>
                            <div className="d-flex flex-row justify-content-start align-items-center my-2">
                                <Typography variant="h5">Location</Typography>
                                <Typography variant="body1" className="mx-2">
                                    {
                                        selectedOrganization.location && selectedOrganization.location.address ?
                                            <a href={`https://google.com/maps/place/${selectedOrganization.location.address.streetAddress} ${selectedOrganization.location.address.city}, ${selectedOrganization.location.address.state} ${selectedOrganization.location.address.zip}`} target="_blank">{`${selectedOrganization.location.address.streetAddress} ${selectedOrganization.location.address.city}, ${selectedOrganization.location.address.state} ${selectedOrganization.location.address.zip}`}</a>
                                            :
                                            loadedLocation && loadedLocation.address ?
                                                <a href={`https://google.com/maps/place/${loadedLocation.address.streetAddress} ${loadedLocation.address.city}, ${loadedLocation.address.state} ${loadedLocation.address.zip}`} target="_blank">{`${loadedLocation.address.streetAddress} ${loadedLocation.address.city}, ${loadedLocation.address.state} ${loadedLocation.address.zip}`}</a>
                                                :
                                                'Not added'
                                    }
                                </Typography>
                            </div>
                            <div className="d-flex flex-row justify-content-start align-items-center my-2">
                                <Typography variant="h5">Phone Number</Typography>
                                <Typography variant="body1" className="mx-2">{selectedOrganization.phoneNumber ? selectedOrganization.phoneNumber : 'Not added'}</Typography>
                            </div>
                            <div className="d-flex flex-row justify-content-start align-items-center my-2">
                                <Typography variant="h5">Website</Typography>
                                <Typography variant="body1" className="mx-2">{selectedOrganization.website ? <a href={selectedOrganization.website.startsWith('https://') ? selectedOrganization.website : `https://${selectedOrganization.website}`} target="_blank">{selectedOrganization.website}</a> : 'Not added'}</Typography>
                            </div>
                            <div className="d-flex flex-row justify-content-start align-items-center my-2">
                                <Typography variant="body1">{selectedOrganization.description ? selectedOrganization.description : 'Not added'}</Typography>
                            </div>
                        </div>
                    </div>
                </div>

                {/* DIALOGS */}
                <ManageOrganization visible={showManageOrganizationDialog} onClose={() => setShowManageOrganizationDialog(false)} />
            </div>
        )
    } else if (selectedOrganization && selectedStaffProfile && selectedStaffProfile.organizationID && selectedStaffProfile.organizationID != selectedOrganization.id) {
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 border-bottom">
                        <div className="d-flex flex-row justify-content-between align-items-center my-5">
                            <Typography variant="h3" sx={{ fontFamily: 'Gilroy-Medium' }}>Organization Profile</Typography>
                        </div>
                    </div>
                    <div className="col-12 col-lg-4 mt-5">
                        <img src={selectedOrganizationHeaderImage ? selectedOrganizationHeaderImage : ''} style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: BORDER_RADIUS }} />
                    </div>
                    <div className="col-12 col-lg-6 mt-lg-5">
                        <div className="d-flex flex-column justify-content-center align-items-start mb-2">
                            <ProfileAvatar organizationID={selectedOrganization.id} size={'large'} className="my-2" />
                            <Typography variant="h3">{selectedOrganization.name}</Typography>
                            <div className="d-flex flex-row justify-content-start align-items-center my-2">
                                <Typography variant="body1">On Flourish since {new Date(selectedOrganization.createdAt).toLocaleDateString()}</Typography>
                            </div>
                            <div className="d-flex flex-row justify-content-start align-items-center my-2">
                                <Typography variant="h5">Location</Typography>
                                <Typography variant="body1" className="mx-2">
                                    {
                                        selectedOrganization.location && selectedOrganization.location.address ?
                                            <a href={`https://google.com/maps/place/${selectedOrganization.location.address.streetAddress} ${selectedOrganization.location.address.city}, ${selectedOrganization.location.address.state} ${selectedOrganization.location.address.zip}`} target="_blank">{`${selectedOrganization.location.address.streetAddress} ${selectedOrganization.location.address.city}, ${selectedOrganization.location.address.state} ${selectedOrganization.location.address.zip}`}</a>
                                            :
                                            loadedLocation && loadedLocation.address ?
                                                <a href={`https://google.com/maps/place/${loadedLocation.address.streetAddress} ${loadedLocation.address.city}, ${loadedLocation.address.state} ${loadedLocation.address.zip}`} target="_blank">{`${loadedLocation.address.streetAddress} ${loadedLocation.address.city}, ${loadedLocation.address.state} ${loadedLocation.address.zip}`}</a>
                                                :
                                                'Not added'
                                    }
                                </Typography>
                            </div>
                            <div className="d-flex flex-row justify-content-start align-items-center my-2">
                                <Typography variant="h5">Phone Number</Typography>
                                <Typography variant="body1" className="mx-2">{selectedOrganization.phoneNumber ? selectedOrganization.phoneNumber : 'Not added'}</Typography>
                            </div>
                            <div className="d-flex flex-row justify-content-start align-items-center my-2">
                                <Typography variant="h5">Website</Typography>
                                <Typography variant="body1" className="mx-2">{selectedOrganization.website ? <a href={selectedOrganization.website.startsWith('https://') ? selectedOrganization.website : `https://${selectedOrganization.website}`} target="_blank">{selectedOrganization.website}</a> : 'Not added'}</Typography>
                            </div>
                            <div className="d-flex flex-row justify-content-start align-items-center my-2">
                                <Typography variant="body1">{selectedOrganization.description ? selectedOrganization.description : 'Not added'}</Typography>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    } else {
        return (
            <div className="container">
                <div className="row">
                    <Typography variant="h5">Loading organization profile</Typography>
                </div>
            </div>
        )
    }
}